import { useCallback, useEffect, useRef, useState } from "react";
import type { ExchangeRate } from "../../domain/types";

export function useExchangeRate(refreshInterval = 30_000) {
  const [rate, setRate] = useState<ExchangeRate | null>(null);
  const [error, setError] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetchRate = useCallback(async () => {
    try {
      // `/api/exchange-rate` es público: es una cotización, no un dato del comercio. No
      // lleva token ni lo necesita, así que tampoco puede dar 401.
      const res = await fetch("/api/exchange-rate");
      if (!res.ok) throw new Error(`${res.status}`);
      const data: ExchangeRate = await res.json();
      setRate(data);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Error fetching rate");
    }
  }, []);

  useEffect(() => {
    fetchRate();
    timer.current = setInterval(fetchRate, refreshInterval);
    return () => {
      if (timer.current) clearInterval(timer.current);
    };
  }, [fetchRate, refreshInterval]);

  return { rate, error };
}
